import * as React from "react";
import {ProcessPage, ProcessStageOrder} from "../../Processes";
import {ClaimAndCheck} from "./ClaimAndCheck";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {VeboxOverlay} from "../../../components/overlay/VeboxOverlay";
import {VeBoxModal} from "../../../components/modal/VeBoxModal";
import {PackagesContext} from "./PackagesProvider";
import {MassiveActionsProcessHeader} from "../components/UtilsComponents";
import {CodesValidation} from "../components/CodesValidation";
import {MassiveActionProcessState} from "../MassiveActionsProvider";

declare var AppTranslations: AppTranslations;


export const PackagesClaim: React.FC = (props) => {
    const context = React.useContext(PackagesContext);
    const packageClaimTranslations = AppTranslations.massiveActions.packageClaimProcess;
    const closeModal = () => overlayController.clear()
    const overlayController = VeboxOverlay.useTarget(
        <PackageStatesModal onClose={closeModal}/>
    );

    const texts = [packageClaimTranslations.codeProgressIndicatorLabel, packageClaimTranslations.claimProgressIndicatorLabel];

    return (
        <ProcessPage total={2} className={"flx-col"}>
            <MassiveActionsProcessHeader
                processHeaderTitle={packageClaimTranslations.title}
                processIndicatorsTitles={texts}
            />
            <VeboxOverlay.Target {...overlayController.targetProps} className={"process-stages flx-row"}>
                <CodesValidation
                    validationFunction={context.fetchPackages}
                    stepNumber={1}
                    stageOrder={ProcessStageOrder.FIRST}
                    title={packageClaimTranslations.packageCodeStageTitle}
                    cardTitle={packageClaimTranslations.packageCodeFormCardTitle}
                    errorMessage={packageClaimTranslations.errorMessageTitle}
                    errorDescription={packageClaimTranslations.errorMessageDescription}
                    massiveActionProcessState={MassiveActionProcessState.INITIAL}
                />
                <ClaimAndCheck overlayController={overlayController}/>
            </VeboxOverlay.Target>
        </ProcessPage>
    )
}


interface PackageStatesModalProps {
    onClose: () => void
}

const PackageStatesModal: React.FC<PackageStatesModalProps> = ({onClose}) => {
    const packageClaimTranslations = AppTranslations.massiveActions.packageClaimProcess;
    return (
        <VeBoxModal.Backdrop>
            <VeBoxModal style={{width: 500}}>
                <VeBoxModal.Header title={packageClaimTranslations.packageStateDialogTitle} onClose={onClose}/>
                <VeBoxModal.Section style={{padding: 20}}>
                    <div className={"legend-item-packages-states"}>
                        <h3 className={"claim legend-item-packages-section-title"}>
                            <span className="material-symbols-outlined ">check_circle</span> {packageClaimTranslations.claimedStatusTitle}
                        </h3>
                        <p>{packageClaimTranslations.claimedStatusDescription}</p>
                    </div>
                    <div className={"legend-item-packages-states"}>
                        <h3 className={"not-claimable legend-item-packages-section-title"}>
                            <span className="material-symbols-outlined ">report_problem</span> {packageClaimTranslations.notClaimableStatusTitle}
                        </h3>
                        <p>{packageClaimTranslations.notClaimableStatusDescription}</p>
                    </div>
                    <div>
                        <h3 className={"not-found legend-item-packages-section-title"}>
                            <span className="material-symbols-outlined">priority_high</span> {packageClaimTranslations.notFoundStatusTitle}
                        </h3>
                        <p>{packageClaimTranslations.notFoundStatusDescription}</p>
                    </div>
                </VeBoxModal.Section>
            </VeBoxModal>
        </VeBoxModal.Backdrop>
    )
}

